import TextField from "@material-ui/core/TextField";
import React from "react";

export const TrimmedTextField = (
    {
        name,
        value,
        onFormChange,
        children,
        ...props
    }: any) => {

    const handleInputBlur = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        const targetName = e.target.name;
        const targetValue = e.target.value;
        onFormChange(targetName, targetValue.trimStart().trimEnd());
    };

    const handleInputChange = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        const targetName = e.target.name;
        const targetValue = e.target.value;
        onFormChange(targetName, targetValue);
    };

    return <TextField
        name={name}
        value={value}
        onBlur={handleInputBlur}
        onChange={handleInputChange}
        {...props}
    />

}
